/* eslint-disable react/forbid-dom-props */
import React from 'react'
interface Props {
  size?: number
}
export const LoveIcon: React.FC<Props> = ({ size = 56 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40">
    <defs>
      <linearGradient
        x1="39.315%"
        y1="99.576%"
        x2="81.296%"
        y2="-14.626%"
        id="love_icon_a"
      >
        <stop stopColor="#FFD773" offset="0%" />
        <stop stopColor="#FEE37B" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle fill="url(#love_icon_a)" cx="20" cy="20" r="20" />
      <path
        d="M10.262 22.471l-.046.029-.027-.018c-8.656-5.475-5.685-10.76-2.473-10.696.103 0 .207.011.31.024 1.293.165 1.902.92 2.19 1.57.287-.65.897-1.405 2.19-1.564 3.312-.429 6.762 5.007-2.144 10.655zM29.833 22.471l-.045.029-.028-.018c-8.655-5.475-5.685-10.76-2.472-10.696.102 0 .206.011.31.024 1.292.165 1.902.92 2.19 1.57.286-.65.897-1.405 2.19-1.564 3.312-.429 6.761 5.007-2.145 10.655z"
        fill="#FD5C3E"
        fillRule="nonzero"
      />
      <path
        d="M3 16c0 11.046 8.954 20 20 20 5.646 0 10.745-2.34 14.382-6.102C33.939 35.932 27.445 40 20 40 8.954 40 0 31.046 0 20 0 14.6 2.14 9.701 5.617 6.103A19.904 19.904 0 003 16z"
        fillOpacity=".05"
        fill="#000"
      />
      <path
        d="M12.647 29.979c1.709 1.68 4.16 2.521 7.353 2.521 4.356 0 7.331-1.564 8.925-4.692a2 2 0 00-2.047-2.89l-1.878.25a37.731 37.731 0 01-10 0 2.823 2.823 0 00-2.353 4.81z"
        fill="#E8AD2B"
      />
    </g>
  </svg>
)
